import { KuoriLogo } from "../../shared/logo.js";

export interface BylineProps {
  readonly onPhoto?: boolean;
}

export function Byline({ onPhoto = false }: BylineProps) {
  return (
    <p class={onPhoto ? "d-byline is-on-photo" : "d-byline"}>
      feito com <KuoriLogo height={13} />
    </p>
  );
}
